__turbopack_context__.v({
  "pillImage": "TextWithPill-module-scss-module__3-Hpwa__pillImage",
  "pillText": "TextWithPill-module-scss-module__3-Hpwa__pillText",
  "pillVideo": "TextWithPill-module-scss-module__3-Hpwa__pillVideo",
  "stack-module-0": "TextWithPill-module-scss-module__3-Hpwa__stack-module-0",
  "stack-module-1": "TextWithPill-module-scss-module__3-Hpwa__stack-module-1",
  "stack-module-10": "TextWithPill-module-scss-module__3-Hpwa__stack-module-10",
  "stack-module-11": "TextWithPill-module-scss-module__3-Hpwa__stack-module-11",
  "stack-module-12": "TextWithPill-module-scss-module__3-Hpwa__stack-module-12",
  "stack-module-13": "TextWithPill-module-scss-module__3-Hpwa__stack-module-13",
  "stack-module-14": "TextWithPill-module-scss-module__3-Hpwa__stack-module-14",
  "stack-module-15": "TextWithPill-module-scss-module__3-Hpwa__stack-module-15",
  "stack-module-16": "TextWithPill-module-scss-module__3-Hpwa__stack-module-16",
  "stack-module-17": "TextWithPill-module-scss-module__3-Hpwa__stack-module-17",
  "stack-module-18": "TextWithPill-module-scss-module__3-Hpwa__stack-module-18",
  "stack-module-19": "TextWithPill-module-scss-module__3-Hpwa__stack-module-19",
  "stack-module-2": "TextWithPill-module-scss-module__3-Hpwa__stack-module-2",
  "stack-module-20": "TextWithPill-module-scss-module__3-Hpwa__stack-module-20",
  "stack-module-3": "TextWithPill-module-scss-module__3-Hpwa__stack-module-3",
  "stack-module-4": "TextWithPill-module-scss-module__3-Hpwa__stack-module-4",
  "stack-module-5": "TextWithPill-module-scss-module__3-Hpwa__stack-module-5",
  "stack-module-6": "TextWithPill-module-scss-module__3-Hpwa__stack-module-6",
  "stack-module-7": "TextWithPill-module-scss-module__3-Hpwa__stack-module-7",
  "stack-module-8": "TextWithPill-module-scss-module__3-Hpwa__stack-module-8",
  "stack-module-9": "TextWithPill-module-scss-module__3-Hpwa__stack-module-9",
  "z-base": "TextWithPill-module-scss-module__3-Hpwa__z-base",
  "z-content": "TextWithPill-module-scss-module__3-Hpwa__z-content",
  "z-footer": "TextWithPill-module-scss-module__3-Hpwa__z-footer",
  "z-header": "TextWithPill-module-scss-module__3-Hpwa__z-header",
  "z-hero": "TextWithPill-module-scss-module__3-Hpwa__z-hero",
  "z-logo": "TextWithPill-module-scss-module__3-Hpwa__z-logo",
  "z-logo-effect": "TextWithPill-module-scss-module__3-Hpwa__z-logo-effect",
  "z-navigation": "TextWithPill-module-scss-module__3-Hpwa__z-navigation",
  "z-sub": "TextWithPill-module-scss-module__3-Hpwa__z-sub",
});
